import { FC } from 'react'
import { ReactComponent as EmptyStateChartIcon } from 'src/assets/svg/empty-state-chart.svg'
import styles from './topicsEmptyState.module.scss'

interface TopicsEmptyStateProps {
  title: string
}

/**
 * Nothing tagged yet. The same shape as the Smart Insights empty state on
 * this page — icon tile, section title, two-line "not enough data" note — so
 * an untagged campaign reads as "not yet" rather than "broken".
 */
export const TopicsEmptyState: FC<TopicsEmptyStateProps> = ({ title }) => (
  <div className={styles.emptyState}>
    <div className={styles.icon}>
      <EmptyStateChartIcon />
    </div>
    <h4 className={styles.title}>{title}</h4>
    <p className={styles.subtitle}>
      There is not enough data yet to detect topics and subtopics.
      <br />
      Please check back later.
    </p>
  </div>
)
